import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useLanguage } from '../../../contexts/LanguageContext';

/**
 * NSherjFh PR 4 — mirrors PRs 2 + 3 confirm modals. Single-snag only
 * (no bulk delete). Copy reflects soft-delete semantics with the
 * comments nuance Heidi flagged: comments persist as a historical
 * thread, become invisible while the parent is deleted, and reappear
 * on restore.
 */
const SnagDeleteConfirmModal = ({ isOpen, onClose, onConfirm, snagTitle }) => {
  const { t } = useLanguage();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-modal flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="bg-card rounded-lg shadow-elevation-5 w-full max-w-md">
        <div className="p-6">
          <div className="flex items-start gap-4 mb-4">
            <div className="flex items-center justify-center w-12 h-12 bg-destructive/10 rounded-full flex-shrink-0">
              <Icon name="AlertTriangle" size={24} color="var(--color-destructive)" />
            </div>
            <div className="flex-1">
              <h2 className="text-lg font-semibold text-foreground mb-2">
                Delete snag?
              </h2>
              <p className="text-sm text-muted-foreground">
                Remove "{snagTitle}" from active views. You can restore it from the Deleted tab.
              </p>
            </div>
          </div>

          <div className="bg-warning/10 border border-warning/20 rounded-lg p-4 mb-6">
            <div className="flex items-start gap-3">
              <Icon name="AlertCircle" size={20} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-foreground mb-1">Comments + status history</p>
                <p className="text-sm text-muted-foreground">
                  Comments on this snag won't be visible to your team while it's deleted. The status (open / in progress / resolved) is preserved. Restoring brings the snag and its comment thread back.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 p-4 border-t border-border bg-muted/30">
          <Button variant="outline" onClick={onClose}>
            {t('cancel')}
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            iconName="Trash2"
            iconPosition="left"
          >
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SnagDeleteConfirmModal;
